<template>
  <div>
    <div class="content-heading">
      <i class="ic-head-icon">
        <img src="@/assets/images/sidebar/punch-card.svg" alt="Punch Card" width="21" class="cursor-pointer" />
      </i>
      <h4 class="head-title">Punch Card</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover target="help" triggers="hover"
        content="Reward repeat purchases effortlessly! The RUSH Punch Card lets customers earn digital stamps for every qualifying transaction, unlocking exclusive rewards once they complete their card."></b-popover>
      <div class="d-flex align-items-end w-100">
        <AppTabs :tabs="tabs" />
        <div class="d-inline-flex align-items-end pb-3">
          <b-button v-if="isShowCreateCampaign" variant="primary" id="button-create-punch-card"
            class="btn-pill d-inline-flex align-items-center justify-content-center"
            @click="$router.push({ name: 'PunchCardCreate' })">
            <img src="@/assets/images/icons/add-big.svg" alt="Create Punch Card" width="14" class="mr-2">
            Create
          </b-button>
          <b-button variant="outline-secondary" id="button-import-punch-card"
            class="btn-pill btn-cancel shadow-none font-weight-bold d-none align-items-center justify-content-center">
            <img src="@/assets/images/icons/import.svg" alt="Import Punch Card" width="19" class="mr-2">
            Import
          </b-button>
        </div>
      </div>
    </div>
    <div class="border-top estore-body punch-card-body">
      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <PunchCardCampaignUpdate :isShowUpdate="isShowUpdate" @hideCampaignUpdate="isShowUpdate = false" />
    <PunchCardCampaignView :isShowView="isShowView" @hideCampaignView="isShowView = false" />
    <PunchCardCampaignQR :isShowQR="isShowQR" @hideCampaignQR="isShowQR = false" />
    <PunchCardLeaveWithoutSavingUpdates :key="`leave-without-saving-modal-${modalOpeningKey}`" />
    <PunchCardUpdateStatusConfirmModal :key="`update-status-modal-${modalOpeningKey}`" />
    <PunchCardClearRewardsConfirmModal :key="`clear-rewards-modal-${modalOpeningKey}`" />
    <PunchCardDeleteRewardConfirmModal :key="`delete-reward-modal-${modalOpeningKey}`" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppTabs from "@/components/common/AppTabs.vue";
import PunchCardCampaignUpdate from "@/components/punch-card/PunchCardCampaignUpdate.vue";
import PunchCardCampaignView from "@/components/punch-card/PunchCardCampaignView.vue";
import PunchCardCampaignQR from "@/components/punch-card/PunchCardCampaignQR.vue";
import PunchCardLeaveWithoutSavingUpdates from "@/components/punch-card/PunchCardLeaveWithoutSavingUpdates.vue";
import PunchCardUpdateStatusConfirmModal from "@/components/punch-card/PunchCardUpdateStatusConfirmModal.vue";
import PunchCardClearRewardsConfirmModal from "@/components/punch-card/create-campaign/design/PunchCardClearRewardsConfirmModal.vue";
import PunchCardDeleteRewardConfirmModal from "@/components/punch-card/create-campaign/design/PunchCardDeleteRewardConfirmModal.vue";

export default {
  components: {
    AppTabs,
    PunchCardCampaignUpdate,
    PunchCardCampaignView,
    PunchCardCampaignQR,
    PunchCardLeaveWithoutSavingUpdates,
    PunchCardUpdateStatusConfirmModal,
    PunchCardClearRewardsConfirmModal,
    PunchCardDeleteRewardConfirmModal
  },
  computed: {
    ...mapState("punchCard", ["modalOpeningKey"]),
    isShowCreateCampaign: {
      get() {
        return this.$route.name !== "PunchCardCreate";
      },
      set(value) {
        return value;
      }
    }
  },
  data() {
    return {
      tabs: [
        {
          name: "List",
          href: "/punch-card",
          access: "punch-card.campaigns"
        },
        {
          name: "Capping",
          href: "/punch-card/capping",
          access: false
        },
        {
          name: "Transaction History",
          href: "/punch-card/transaction-history",
          access: false
        }
      ],
      isShowView: false,
      isShowUpdate: false,
      isShowQR: false
    }
  },
  mounted() {
    document.getElementById("app-content").style.backgroundColor = "white";

    this.$root.$on("openViewCampaign", () => this.isShowView = true);

    this.$root.$on("openCampaignUpdate", (uuid) => {
      this.isShowUpdate = true;
    });

    this.$root.$on("openCampaignQR", () => this.isShowQR = true);
  },
  beforeDestroy() {
    document.getElementById("app-content").style.backgroundColor = null;
    this.$root.$off("openCampaignUpdate");
    this.$root.$off("openViewCampaign");
    this.$root.$off("openCampaignQR");
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 150px;
  height: 48px;

  &#button-import-punch-card {
    border-color: #49545C;
    color: #49545C;

    &:hover {
      background-color: transparent;
    }
  }
}

.punch-card-body {
  margin-top: 1px;
  padding-top: 56px !important;
}
</style>
